import { IButton as Props } from "./stores/types";
import { Loader } from "@storybook/loader";

import "./button.scss";
import GlobalInstanceManager from "instance-manger";

/**
 * Button component
 *
 * @param {string | JSX.Element } Props.label - The label text for the button
 * @param {MouseEventHandler<HTMLButtonElement>} Props.handleClick - Callback function triggered on button click
 * @param {JSX.Element | any} Props.loader - Loader component to display while the button is in a loading state
 * @param {string} Props.type - The type of button (e.g., "button__filled--primary", "button__filled--secondary")
 * @param {string} Props.icon - CSS class for an icon to be displayed on the button
 * @param {string} Props.height - The height of the button
 * @param {boolean} Props.disabled - Flag to indicate whether the button is disabled
 * @param {string} Props.buttonType - The HTML button type attribute ("button", "submit", or "reset")
 * @param {string} Props.prefixIcon - CSS class for an icon to be displayed before the label
 * @param {string} Props.minHeight - The minimum height of the button
 * @param {string} Props.width - The width of the button
 * @param {string | undefined} Props.id - The id of the button
 */

export const Button = ({
  label,
  handleClick,
  loader,
  type,
  icon,
  height,
  disabled,
  buttonType,
  prefixIcon,
  minHeight,
  width,
  id = "",
}: Props) => {
  const { styles } = GlobalInstanceManager.webcomponentProps;
  return (
    <button
      className={`button ${type} ${disabled ? "button--disabled" : ""}`}
      onClick={handleClick}
      style={{ minHeight, height, width, ...styles?.button }}
      disabled={disabled}
      type={buttonType}
      id={id}
    >
      {prefixIcon && <i className={prefixIcon} />}
      {!loader && <div className="button-label-txt">{label}</div>}
      {loader && (
        <div className="button-loader-wrapper">
          <div className="button-label-txt">{label}</div>
          <Loader dimension={20} type="loader" className="loader-white" />
        </div>
      )}
      {icon && <i className={icon} />}
    </button>
  );
};